export const environment = {
  production: false,
  apiBaseUrl: 'https://dev-nexusapi.blockchainx.tech',
  mixpanelToken: 'a887d6cbce64c72b190cfceee315b85d',
  gaTrackingId: 'G-TXRY9D29J5'
};
